import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Landing from "./views/Landing.vue";
import Products from "./views/Products.vue";
import Product from "./views/Product.vue";
import Catalogs from "./views/Catalogs.vue";
import AboutUs from "./views/AboutUs.vue";
import ContactUs from "./views/ContactUs.vue";
import PrivacyPolicy from "./views/PrivacyPolicy.vue";
import Range from "./views/Range.vue";
import Category from "./views/Category.vue";
import SubCategory from "./views/SubCategory.vue";

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "Home",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/ranges/:rangeId",
      name: "Range",
      components: {
        header: AppHeader,
        default: Range,
        footer: AppFooter
      }
    },
    {
      path: "/ranges/:rangeId/categories/:categoryId",
      name: "Category",
      components: {
        header: AppHeader,
        default: Category,
        footer: AppFooter
      }
    },
    {
      path:
        "/ranges/:rangeId/categories/:categoryId/sub-categories/:subCategoryId",
      name: "Sub-Category",
      components: {
        header: AppHeader,
        default: SubCategory,
        footer: AppFooter
      }
    },
    {
      path: "/products",
      name: "Products",
      components: {
        header: AppHeader,
        default: Products,
        footer: AppFooter
      }
    },
    {
      path: "/products/:productId",
      name: "Product",
      components: {
        header: AppHeader,
        default: Product,
        footer: AppFooter
      }
    },
    {
      path: "/catalogues",
      name: "Catalogues",
      components: {
        header: AppHeader,
        default: Catalogs,
        footer: AppFooter
      }
    },
    {
      path: "/about-us",
      name: "About Us",
      components: {
        header: AppHeader,
        default: AboutUs,
        footer: AppFooter
      }
    },
    {
      path: "/contact-us",
      name: "Contact Us",
      components: {
        header: AppHeader,
        default: ContactUs,
        footer: AppFooter
      }
    },
    {
      path: "/privacy-policy",
      name: "Privacy Policy",
      components: {
        header: AppHeader,
        default: PrivacyPolicy,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// close the dropdown navbar whenever the route changes
router.beforeEach((to, from, next) => {
  const isExpanded = $(".navbar-toggler").attr("aria-expanded");
  if (isExpanded) {
    $(".navbar-toggler").click();
  }
  next();
});

export default router;
